import {EntityContainerHashParamsModel} from "../../../core/components/router/models/entity-container-hash-params-model";

export class CompetitorContainerHashParamsModel extends EntityContainerHashParamsModel {
  brackets: Number;
}
